import React from 'react';
import SuccessStoryCard from '@/components/personas/ta-leaders/success-stories/SuccessStoryCard';

const successStories = [
  {
    logo: "/lovable-uploads/Fractal.png",
    highlight: "Made 12 offers in 2 months",
    description: "Staffed a critical client project within timelines"
  },
  {
    logo: "/lovable-uploads/StepSecurity.png",
    highlight: "Hired first candidate sourced on day 2",
    description: "Saved ₹2 Lakhs in agency fees"
  },
  {
    logo: "/lovable-uploads/Callhub.png",
    highlight: "Found a hidden candidate due to AI interviews",
    description: "At 40% of expected CTC"
  }
];

const ProductVideo = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container px-4 mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-darkgrey mb-12">
          See it in action
        </h2>
        
        <div className="max-w-4xl mx-auto aspect-video rounded-3xl overflow-hidden shadow-medium border border-gray-100 bg-gray-50 mb-24">
          <iframe 
            width="100%" 
            height="100%" 
            src="https://www.youtube.com/embed/xLNqwMfVbwM?si=grDxsVuFvRN_IzVv" 
            title="Cutshort Product Walkthrough" 
            frameBorder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
            referrerPolicy="strict-origin-when-cross-origin" 
            allowFullScreen
            className="w-full h-full"
          ></iframe>
        </div>

        <div className="max-w-6xl mx-auto">
          <h3 className="text-2xl md:text-3xl font-bold text-brand-darkgrey mb-12">
            Creating success stories every day
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {successStories.map((story, index) => (
              <SuccessStoryCard
                key={index}
                logo={story.logo}
                highlight={story.highlight}
                description={story.description}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductVideo;
